import {
    ESTACIO_INICIALITZAR,
    ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS
} from '../../actions/actionTypes';

const ESTAT_INICIAL_ESTACIONS = {};

const totes = (state = ESTAT_INICIAL_ESTACIONS, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL_ESTACIONS;

        case ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS:
            return action.estacions;

        default:
            return state;
    }
};

export default totes;



// WEBPACK FOOTER //
// ./src/reducers/estacio/totes.js